<template>
  <!-- eslint-disable -->
<div style="text-align:left; background-color: #fafbfc;">
 
  
  <div class="column-left">
    <SideNav />
  </div>

  
  <div class="column-right">
    <TopNav />
    <div class="main-container">   
      
      <div v-if="loaded" class="articulo-principal">
        <!-- Header Section -->
        <div class="page-header">
          <div class="header-content">
            <div class="header-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" :fill="prestador.admin.assets.colors.primary"/>
              </svg>
            </div>
            <div class="header-text">
              <h1 class="page-title">Códigos de descuento</h1>
              <p class="page-subtitle">Gestiona los códigos promocionales para tus servicios médicos</p>
            </div>
          </div>
        </div>

        <!-- Add New Code Section -->
        <div class="add-code-section">
          <div class="section-card">
            <div class="card-header">
              <div class="card-header-content">
                <div class="card-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <h2 class="card-title">Agregar un nuevo código</h2>
              </div>
            </div>
            
            <div class="card-body">
              <!-- Desktop Form -->
              <div class="desktop-form">
                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label">Nombre del código</label>
                    <input
                      v-model="nombre"
                      type="text"
                      class="form-input"
                      placeholder="Ej: Descuento Navidad"
                    >
                  </div>
                  
                  <div class="form-group">
                    <label class="form-label">Código promocional</label>
                    <input
                      v-model="codigo"
                      type="text"
                      class="form-input"
                      placeholder="Ej: NAVIDAD2024"
                    >
                  </div>
                  
                  <div class="form-group">
                    <label class="form-label">Fecha inicio</label>
                    <input
                      v-model="dt_dia"
                      type="date"
                      class="form-input date-input"
                    >
                  </div>
                  
                  <div class="form-group">
                    <label class="form-label">Fecha término</label>
                    <input
                      v-model="dt_dia2"
                      type="date"
                      class="form-input date-input"
                    >
                  </div>
                  
                  <div class="form-group">
                    <button
                      class="add-button"
                      :style="{'background-color': prestador.admin.assets.colors.primary}"
                      @click="agregar_codigo()"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Agregar Código
                    </button>
                  </div>
                </div>
              </div>

              <!-- Mobile Form -->
              <div class="mobile-form">
                <div class="mobile-form-grid">
                  <div class="form-group">
                    <label class="form-label">Nombre del código</label>
                    <input
                      v-model="nombre"
                      type="text"
                      class="form-input"
                      placeholder="Ej: Descuento Navidad"
                    >
                  </div>
                  
                  <div class="form-group">
                    <label class="form-label">Código promocional</label>
                    <input
                      v-model="codigo"
                      type="text"
                      class="form-input"
                      placeholder="Ej: NAVIDAD2024"
                    >
                  </div>
                  
                  <div class="date-group">
                    <div class="form-group">
                      <label class="form-label">Fecha inicio</label>
                      <input
                        v-model="dt_dia"
                        type="date"
                        class="form-input date-input"
                      >
                    </div>
                    
                    <div class="form-group">
                      <label class="form-label">Fecha término</label>
                      <input
                        v-model="dt_dia2"
                        type="date"
                        class="form-input date-input"
                      >
                    </div>
                  </div>
                  
                  <button
                    class="add-button-mobile"
                    :style="{'background-color': prestador.admin.assets.colors.primary}"
                    @click="agregar_codigo()"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Agregar Código
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Existing Codes Section -->
        <div class="codes-section">
          <div class="section-card">
            <div class="card-header">
              <div class="card-header-content">
                <div class="card-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" fill="currentColor"/>
                  </svg>
                </div>
                <h2 class="card-title">Códigos existentes</h2>
              </div>
              <div class="codes-count">
                <span class="count-badge">{{ codigos.length }} códigos</span>
              </div>
            </div>
            
            <div class="card-body">
              <!-- Desktop Table -->
              <div class="desktop-table">
                <div class="table-container">
                  <table class="codes-table">
                    <thead>
                      <tr class="table-header">
                        <th class="th-id">ID</th>
                        <th class="th-name">Nombre</th>
                        <th class="th-code">Código</th>
                        <th class="th-date">Fecha Inicio</th>
                        <th class="th-date">Fecha Término</th>
                        <th class="th-actions">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="c in codigos" :key="c.id" class="table-row">
                        <td class="td-id">
                          <span class="id-badge">#{{ c.id }}</span>
                        </td>
                        <td class="td-name">
                          <div class="name-cell">
                            <div class="name-icon">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" :fill="prestador.admin.assets.colors.primary"/>
                              </svg>
                            </div>
                            <span class="name-text">{{ c.nombre }}</span>
                          </div>
                        </td>
                        <td class="td-code">
                          <span class="code-badge">{{ c.codigo }}</span>
                        </td>
                        <td class="td-date">
                          <div class="date-cell">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" fill="#64748b"/>
                            </svg>
                            <span class="date-text">{{ new Date(c.fecha_inicio.a, c.fecha_inicio.m-1, c.fecha_inicio.d).toLocaleDateString("es-ES", { year: 'numeric', month: 'long', day: 'numeric' }) }}</span>
                          </div>
                        </td>
                        <td class="td-date">
                          <div class="date-cell">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" fill="#64748b"/>
                            </svg>
                            <span class="date-text">{{ new Date(c.fecha_termino.a, c.fecha_termino.m-1, c.fecha_termino.d).toLocaleDateString("es-ES", { year: 'numeric', month: 'long', day: 'numeric' }) }}</span>
                          </div>
                        </td>
                        <td class="td-actions">
                          <div class="actions-group">
                            <button
                              class="action-button edit-button"
                              :style="{'background-color': prestador.admin.assets.colors.secondary}"
                              @click="$router.push('/EditarCodigo/'+c.id)"
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M18.5 2.50023C18.8978 2.1024 19.4374 1.87891 20 1.87891C20.5626 1.87891 21.1022 2.1024 21.5 2.50023C21.8978 2.89805 22.1213 3.43762 22.1213 4.00023C22.1213 4.56284 21.8978 5.1024 21.5 5.50023L12 15.0002L8 16.0002L9 12.0002L18.5 2.50023Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </button>
                            <button
                              class="action-button delete-button"
                              @click="eliminar_codigo(c.id)"
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 6H5H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Mobile Cards -->
              <div class="mobile-cards">
                <div v-for="c in codigos" :key="c.id" class="code-card">
                  <div class="code-card-header">
                    <div class="code-card-title">
                      <div class="code-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" :fill="prestador.admin.assets.colors.primary"/>
                        </svg>
                      </div>
                      <div class="code-title-text">
                        <h3 class="code-name">{{ c.nombre }}</h3>
                        <span class="code-id">#{{ c.id }}</span>
                      </div>
                    </div>
                    <div class="code-badge-mobile">{{ c.codigo }}</div>
                  </div>
                  
                  <div class="code-card-body">
                    <div class="date-info">
                      <div class="date-item">
                        <div class="date-label">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" fill="#64748b"/>
                          </svg>
                          <span>Inicio</span>
                        </div>
                        <span class="date-value">{{ new Date(c.fecha_inicio.a, c.fecha_inicio.m-1, c.fecha_inicio.d).toLocaleDateString("es-ES", { year: 'numeric', month: 'short', day: 'numeric' }) }}</span>
                      </div>
                      
                      <div class="date-separator">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#94a3b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      
                      <div class="date-item">
                        <div class="date-label">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" fill="#64748b"/>
                          </svg>
                          <span>Término</span>
                        </div>
                        <span class="date-value">{{ new Date(c.fecha_termino.a, c.fecha_termino.m-1, c.fecha_termino.d).toLocaleDateString("es-ES", { year: 'numeric', month: 'short', day: 'numeric' }) }}</span>
                      </div>
                    </div>
                  </div>
                  
                  <div class="code-card-footer">
                    <button
                      class="action-button-mobile edit-button-mobile"
                      :style="{'background-color': prestador.admin.assets.colors.secondary}"
                      @click="$router.push('/EditarCodigo/'+c.id)"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.5 2.50023C18.8978 2.1024 19.4374 1.87891 20 1.87891C20.5626 1.87891 21.1022 2.1024 21.5 2.50023C21.8978 2.89805 22.1213 3.43762 22.1213 4.00023C22.1213 4.56284 21.8978 5.1024 21.5 5.50023L12 15.0002L8 16.0002L9 12.0002L18.5 2.50023Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Editar
                    </button>
                    <button
                      class="action-button-mobile delete-button-mobile"
                      @click="eliminar_codigo(c.id)"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 6H5H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="articulo-principal">
        <div class="loader-container">
          <Loader :height="100" :width="100" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import {mapGetters, mapActions} from 'vuex';
import SideNav from '@/components/SideNav.vue';
import Loader from '@/components/Loader.vue';
import TopNav from '@/components/TopNav.vue';

export default {
  name: 'HelloWorld',
  components:{
    TopNav,
    Loader,
    SideNav,
  },
  data() {
    return {
      dt_dia:'',
      dt_dia2:'',
      loaded:false,
      codigos:[],
      nombre:'',
      codigo:'',
      desde:{d:0, m:0, a:0},
      hasta:{d:0, m:0, a:0},

    }
  },
  created(){
  
    this.initialize_();
  },

  methods:{
    ...mapActions(['initialize']),







    
  initialize_(){
    //this.loaded = false;
      axios.get(window.hostname+'/api/admin/initialize_codigos')
      .then(response => 
      {
        this.loaded = true;
        this.codigos = response.data.codigos;
      })         
      .catch(e=>
      {
          this.loaded = true;
      })
  },


  agregar_codigo(){
      axios.post(window.hostname+'/api/admin/agregar_codigo',
      {nombre:this.nombre, codigo:this.codigo,
        dia:this.desde.d, mes:this.desde.m, año:this.desde.a,
         dia2:this.hasta.d, mes2:this.hasta.m, año2:this.hasta.a}
         )
      .then(response => 
      {
        this.initialize_()
      })         
      .catch(e=>
      {

      })
  },


  eliminar_codigo(id){
      axios.post(window.hostname+'/api/admin/eliminar_codigo',
      {codigo_id:id}
         )
      .then(response => 
      {
        this.initialize_()
      })         
      .catch(e=>
      {

      })
  },


  },
  computed:{
    ...mapGetters(['comunas', 'regiones', 'prestaciones', 'prestador', 'admin_datos', 'examenes', 'aseguradoras', 'descuentos']),
  },
  watch:{
    dt_dia(val){

        var datos = val.split('-')
        this.desde = {a:Number(datos[0]), m:Number(datos[1]), d:Number(datos[2])}
      
    },
    dt_dia2(val){

        var datos = val.split('-')
        this.hasta = {a:Number(datos[0]), m:Number(datos[1]), d:Number(datos[2])}
      
    },
  },
  mounted() {
  }

}
</script>


<style scoped>
/* Layout Principal */
.column-right {
  background-color: #fafbfc;
  padding-top: 0px;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
}

.main-container {
  background-color: #fafbfc;
  padding: 24px;
  margin-top: 10px;
}

.articulo-principal {
  min-height: calc(100vh - 120px);
  max-width: 1200px;
  margin: 0 auto;
}

/* Header */
.page-header {
  margin-bottom: 32px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #0ea5e9, #10b981);
  border-radius: 12px;
  color: white;
}

.header-text {
  flex: 1;
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 4px 0;
  letter-spacing: -0.025em;
}

.page-subtitle {
  font-size: 1rem;
  color: #64748b;
  margin: 0;
  font-weight: 500;
}

/* Section Cards */
.add-code-section {
  margin-bottom: 32px;
}

.codes-section {
  margin-bottom: 32px;
}

.section-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.card-header {
  padding: 24px 32px;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #0ea5e9;
  border-radius: 8px;
  color: white;
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.codes-count {
  display: flex;
  align-items: center;
}

.count-badge {
  padding: 4px 12px;
  background: #eff6ff;
  color: #1e40af;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
}

.card-body {
  padding: 32px;
}

/* Forms */
.desktop-form {
  display: block;
}

.mobile-form {
  display: none;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr auto;
  gap: 20px;
  align-items: end;
}

.mobile-form-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.date-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.form-input {
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.875rem;
  background-color: #ffffff;
  transition: all 0.2s ease;
  color: #1f2937;
}

.form-input:focus {
  outline: none;
  border-color: #0ea5e9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
}

.form-input::placeholder {
  color: #9ca3af;
}

.date-input {
  font-family: inherit;
}

.add-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background-color: #0ea5e9;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.add-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.add-button-mobile {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 24px;
  background-color: #0ea5e9;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.add-button-mobile:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

/* Desktop Table */
.desktop-table {
  display: block;
}

.mobile-cards {
  display: none;
}

.table-container {
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.codes-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.table-header {
  background-color: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.table-header th {
  padding: 16px 20px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  border-right: 1px solid #f1f5f9;
}

.table-header th:last-child {
  border-right: none;
}

.th-id {
  width: 80px;
}

.th-name {
  width: 25%;
}

.th-code {
  width: 20%;
}

.th-date {
  width: 20%;
}

.th-actions {
  width: 120px;
  text-align: center;
}

.table-row {
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: #f8fafc;
}

.table-row td {
  padding: 16px 20px;
  vertical-align: middle;
  border-right: 1px solid #f1f5f9;
}

.table-row td:last-child {
  border-right: none;
}

/* Table Cell Styles */
.td-id {
  text-align: center;
}

.id-badge {
  padding: 4px 8px;
  background: #f1f5f9;
  color: #64748b;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  font-family: 'Monaco', 'Menlo', monospace;
}

.name-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.name-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #eff6ff;
  border-radius: 6px;
}

.name-text {
  font-weight: 600;
  color: #1e293b;
}

.code-badge {
  padding: 6px 12px;
  background: linear-gradient(135deg, #0ea5e9, #10b981);
  color: white;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-family: 'Monaco', 'Menlo', monospace;
}

.date-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.date-text {
  color: #64748b;
  font-size: 0.8rem;
}

.actions-group {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.action-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: white;
}

.edit-button {
  background-color: #10b981;
}

.edit-button:hover {
  background-color: #059669;
  transform: translateY(-1px);
}

.delete-button {
  background-color: #ef4444;
}

.delete-button:hover {
  background-color: #dc2626;
  transform: translateY(-1px);
}

/* Mobile Cards */
.code-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.2s ease;
  margin-bottom: 16px;
}

.code-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.code-card-header {
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.code-card-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.code-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #eff6ff;
  border-radius: 8px;
}

.code-title-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.code-name {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.code-id {
  font-size: 0.75rem;
  color: #64748b;
  font-family: 'Monaco', 'Menlo', monospace;
}

.code-badge-mobile {
  padding: 6px 12px;
  background: linear-gradient(135deg, #0ea5e9, #10b981);
  color: white;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-family: 'Monaco', 'Menlo', monospace;
}

.code-card-body {
  padding: 20px;
}

.date-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.date-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.date-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.date-value {
  font-size: 0.875rem;
  color: #1e293b;
  font-weight: 500;
}

.date-separator {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.code-card-footer {
  padding: 16px 20px;
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  gap: 12px;
}

.action-button-mobile {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
  color: white;
}

.edit-button-mobile {
  background-color: #10b981;
}

.edit-button-mobile:hover {
  background-color: #059669;
  transform: translateY(-1px);
}

.delete-button-mobile {
  background-color: #ef4444;
}

.delete-button-mobile:hover {
  background-color: #dc2626;
  transform: translateY(-1px);
}

/* Loader */
.loader-container {
  height: calc(100vh - 140px);
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .column-left {
    display: none;
  }
  .column-right {
    padding-left: 0px;
  }
  .main-container {
    padding: 20px;
  }
  
  .form-row {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 16px;
  }
  
  .form-row .form-group:nth-child(4),
  .form-row .form-group:nth-child(5) {
    grid-column: span 3;
  }
}

@media (max-width: 992px) {
  .desktop-form {
    display: none;
  }
  
  .mobile-form {
    display: block;
  }
  
  .desktop-table {
    display: none;
  }
  
  .mobile-cards {
    display: block;
  }
}

@media (max-width: 800px) {
  .main-container {
    padding: 16px;
  }
  
  .page-header {
    margin-bottom: 24px;
  }
  
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .page-title {
    font-size: 1.5rem;
  }
  
  .card-header {
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .card-body {
    padding: 20px;
  }
  
  .date-group {
    grid-template-columns: 1fr;
  }
  
  .date-info {
    flex-direction: column;
    gap: 20px;
  }
  
  .date-separator {
    transform: rotate(90deg);
  }
}

@media (max-width: 480px) {
  .main-container {
    padding: 12px;
  }
  
  .header-icon {
    width: 40px;
    height: 40px;
  }
  
  .page-title {
    font-size: 1.25rem;
  }
  
  .page-subtitle {
    font-size: 0.875rem;
  }
  
  .card-header {
    padding: 16px;
  }
  
  .card-body {
    padding: 16px;
  }
  
  .code-card-header {
    padding: 12px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .code-card-body {
    padding: 16px;
  }
  
  .code-card-footer {
    padding: 12px 16px;
    flex-direction: column;
    gap: 8px;
  }
  
  .action-button-mobile {
    padding: 12px 16px;
  }
}

/* Animaciones suaves */
@media (prefers-reduced-motion: no-preference) {
  .section-card,
  .code-card,
  .add-button,
  .add-button-mobile,
  .action-button,
  .action-button-mobile,
  .form-input {
    transition: all 0.2s ease;
  }
}
</style>